import { render } from "./campaignForm.vue?vue&type=template&id=2c6fc5d5&scoped=true"
import script from "./campaignForm.vue?vue&type=script&lang=js"
export * from "./campaignForm.vue?vue&type=script&lang=js"

import "./campaignForm.vue?vue&type=style&index=0&id=2c6fc5d5&lang=scss"
import "./campaignForm.vue?vue&type=style&index=1&id=2c6fc5d5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6fc5d5"]])

export default __exports__